<template>
    <v-menu offset-y left>
        <template #activator="{ on, attrs }">
            <v-list-item link v-bind="attrs" v-on="on" class="config-item">
                <v-list-item-title>
                    {{ $t('common.language') }}
                </v-list-item-title>
                <v-list-item-action class="my-0">
                    <span class="current-locale">{{ currentLabel }}</span>
                </v-list-item-action>
            </v-list-item>
        </template>
        <v-list dense>
            <v-list-item v-for="loc in locales" :key="loc.value" @click="select(loc.value)">
                <v-list-item-title>
                    {{ loc.flag }} {{ loc.label }}
                </v-list-item-title>
                <v-icon v-if="loc.value === current" small color="secondary" class="ml-3">mdi-check</v-icon>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import { LOCALES, applyLocale } from '@/utils/Locale'
import { db } from '@/utils/Firebase'

export default {
    name: 'LanguageSelector',
    data() {
        return {
            locales: LOCALES
        }
    },
    computed: {
        current(vm = this) {
            return vm.$i18n.locale
        },
        currentLabel(vm = this) {
            const found = vm.locales.find(l => l.value === vm.current)
            return found ? `${found.flag} ${found.label}` : ''
        }
    },
    methods: {
        async select(locale) {
            const vm = this
            if (locale === vm.current) return
            applyLocale(locale, vm.$vuetify)
            const uid = vm.currentUser?.uid
            if (uid) {
                try {
                    await db.collection('users').doc(uid).update({ language: locale })
                } catch (e) {
                    console.log('update language err', e)
                }
            }
        }
    }
}
</script>

<style scoped>
.current-locale {
    font-size: 13px;
    color: var(--v-txtMuted-base);
}
</style>
